import { useState } from "react";
import { View, Text } from "../base";
import { Icon } from "../base/Icon";
import { JsonViewer } from "../base/JsonViewer";
import { SpanDetailTabs, TabDefinition } from "./SpanDetailTabs";
import { RawSpanDetailView, RawSpanData } from "./RawSpanDetailView";

export interface ToolSpanData {
  input?: string;
  output?: string;
  description?: string;
}

// Content component for the Tool tab
const ToolContent = ({ data }: { data: ToolSpanData }) => {
  return (
    <View className="space-y-4">
      {/* Tool Description */}
      {data.description && (
        <View className="bg-amber-50 dark:bg-amber-900/20 rounded-lg p-3 border border-amber-200 dark:border-amber-800">
          <Text className="text-sm text-gray-700 dark:text-gray-300">{data.description}</Text>
        </View>
      )}

      {/* Tool Input */}
      {data.input && (
        <View>
          <View className="flex flex-row items-center gap-2 mb-2">
            <Icon
              name="input"
              size={14}
              className="text-amber-500 dark:text-amber-400"
            />
            <Text className="text-sm font-medium text-gray-700 dark:text-gray-300">Input</Text>
          </View>
          <View className="bg-gray-50 dark:bg-gray-800 rounded-lg p-3 border border-gray-200 dark:border-gray-700">
            <JsonViewer
              data={data.input}
              collapsed={10}
              className="p-2"
            />
          </View>
        </View>
      )}

      {/* Tool Output */}
      {data.output && (
        <View>
          <View className="flex flex-row items-center gap-2 mb-2">
            <Icon
              name="data-array"
              size={14}
              className="text-emerald-500 dark:text-emerald-400"
            />
            <Text className="text-sm font-medium text-gray-700 dark:text-gray-300">Output</Text>
          </View>
          <View className="bg-emerald-50 dark:bg-emerald-900/20 rounded-lg p-3 border border-emerald-200 dark:border-emerald-800">
            <JsonViewer
              data={data.output}
              collapsed={10}
              className="p-2"
            />
          </View>
        </View>
      )}
    </View>
  );
};

// Main ToolSpanDetailView component with tabs
interface ToolSpanDetailViewProps {
  data: ToolSpanData;
  rawData: RawSpanData;
  className?: string;
}

const tabs: TabDefinition[] = [
  { id: "tool", label: "Tool", color: "amber" },
  { id: "attributes", label: "Attributes", color: "gray" },
];

export const ToolSpanDetailView = ({ data, rawData, className }: ToolSpanDetailViewProps) => {
  const [activeTab, setActiveTab] = useState("tool");

  return (
    <View className={`flex flex-col overflow-hidden h-full ${className || ""}`}>
      <SpanDetailTabs
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
      />
      <View className="flex-1 overflow-y-auto p-4">{activeTab === "tool" ? <ToolContent data={data} /> : <RawSpanDetailView data={rawData} />}</View>
    </View>
  );
};
